// extracted by mini-css-extract-plugin
export var option = "_53-0";
export var optionCard = "_53-f";
export var optionContent = "_53-g";
export var optionIcon = "_53-i";
export var optionIconBox = "_53-h";
export var optionLabel = "_53-j";
export var optionPill = "_53-m";
export var optionPillBadge = "_53-p";
export var optionPillIcon = "_53-n";
export var optionPillLabel = "_53-o";
export var optionRadio = "_53-k";
export var optionRadioInner = "_53-l";
export var optionReveal = "_53-2";
export var optionRevealDelay0 = "_53-3";
export var optionRevealDelay1 = "_53-4";
export var optionRevealDelay10 = "_53-d";
export var optionRevealDelay11 = "_53-e";
export var optionRevealDelay2 = "_53-5";
export var optionRevealDelay3 = "_53-6";
export var optionRevealDelay4 = "_53-7";
export var optionRevealDelay5 = "_53-8";
export var optionRevealDelay6 = "_53-9";
export var optionRevealDelay7 = "_53-a";
export var optionRevealDelay8 = "_53-b";
export var optionRevealDelay9 = "_53-c";
export var optionSelected = "_53-1";